<template>

    <loading v-bind:loading="loading" />

   <sirit-right-menu size="md">
          <template v-slot:rightMenuContent>
            <div class="modal-header w-full flex flex-shrink-0 border-b border-gray-200 rounded-t-md">
                <span @click="closeModal()" class="cursor-pointer font-bold text-xl hover:text-sirit_blue-400">x</span>
                <span class="text-md ml-2 text-black mt-1">Cerrar</span>
            </div>

                <div v-if="!loading && comments.length > 0" id="messages" class="flex flex-col w-full space-y-1 p-2 overflow-y-auto scrollbar-thumb-blue scrollbar-thumb-rounded scrollbar-track-blue-lighter scrollbar-w-2 scrolling-touch " style="max-height:76%">     
                    <div :class="[item.commentsCountUnread > 0 ? 'bg-sirit_blue-50 text-sirit_blue-500' : 'bg-white']" class="border-b chat-message h-20  grid grid-cols-8 cursor-pointer hover:text-sirit_blue-100 px-2" v-for="item in comments" v-bind:key="item.id" v-bind:item="item" @click="() => setDebtorCaseId(item.debtorCaseId, item.clientReference, item.participantName)">
                        <div class="flex items-start col-span-7">
                            <fa icon="envelope" class="m-auto" />
                            <div class="w-full flex flex-col space-y-2 max-w-xs mx-2 order-2 items-start">
                                <div class="w-full px-4 py-2 rounded-lg inline-block  text-black">
                                    <h3 class="text-md font-bold">Fra {{item.clientReference}}</h3>
                                    <span class="text-md ">{{item.participantName}}</span>
                                </div>
                                            
                                </div>
                            </div>
                            <div class="flex text-right">
                            <fa icon="angle-right" class="m-auto text-black"  />
                            </div>      
                        </div>
                    </div>
                    <div v-else-if="!loading && comments.length == 0" class="py-40 text-center"><span class="m-auto">No hay registros disponibles</span> </div>
            
         </template>
    </sirit-right-menu>   

    <comment-modal v-if="openModalComment"  @onFire="eventOpenModal_comment" :openModal="openModalComment" v-bind:item="item" />

</template>

<script lang="ts">
import axios from 'axios'
import {reactive, toRefs} from 'vue';
import * as global from '@/api/global'
import CommentModal from '@/components/Debt/CommentModal.vue'
import loading from '@/components/Commons/Loading.vue'
import SiritRightMenu from '@/components/Commons/SiritRightMenu.vue'

export default {
    name: 'NotificationModal',
    components: {CommentModal, loading, SiritRightMenu},
    props: {
    openModal: { type: Boolean, required: true, default: false },
    },
    emits: ['onFire'],
  setup (props: any, { emit } : any) {

    interface comment_ {
      loading: Boolean
      comments: Array<any>
      openModalComment: Boolean
      item: {
          id: Number
          clientReference: String
          mainParticipant: String
      }
    }

    let data = reactive<comment_>({
      loading: false,
      comments: [],
      openModalComment: false,
      item: {
          id:0,
          clientReference: '',
          mainParticipant:''
      }
    })

    let errors = reactive([{
        code: 16691464,
        msg: "1"
    }]);

    const closeModal = () => {
        emit("onFire")
    }

    const eventOpenModal_comment = () => {
        data.openModalComment = !data.openModalComment;
    }

    const setDebtorCaseId = (id:Number, clientReference: String, participantName: String) => {
       data.item.id = id;
       data.item.clientReference = clientReference;
       data.item.mainParticipant = participantName;
       data.openModalComment=!data.openModalComment;
        
    }

    const getComments = async () => {
      data.loading = true;
      const url =  process.env.VUE_APP_BASE_URL+`/client/${global.getClietIdSession()}/comments`;
      let response = null
      try {
        response = await axios.get(url,  {
            headers: {
                Authorization: `Bearer ${global.getToken()}`
            }
        })
      } catch (e: any) {
          response = e.response;
      }

      if(response.status== 200){ 
        data.comments = response.data;
      }else{
        errors = response.data;
      }
      data.loading = false;
    }

    getComments();

    return {
      closeModal,
      eventOpenModal_comment,
      getComments,
      setDebtorCaseId,
      errors,
      global,
      ...toRefs(data)
    }

  }

}

</script>
